import Alert from "@pathwright/ui/src/components/alert/Alert"
import { useContextualFeaturePermissionQuery } from "../../api/generated"
import { featurePermissionsQueryPropTypes } from "../propTypes"
import FeatureBlock from "./FeatureBlock"

const FeatureBlockContainer = ({ featureKey, featureAction, context, to }) => {
  const cfpQuery = useContextualFeaturePermissionQuery({
    variables: {
      featureKey,
      featureAction,
      context
    }
  })

  if (cfpQuery.loading) return null
  if (cfpQuery.error) return <Alert error={cfpQuery.error} />

  const feature = cfpQuery.data.contextualFeaturePermission

  return (
    <FeatureBlock
      featureKey={feature.feature_key}
      featurePermission={feature.permission_in_context}
      to={to}
    />
  )
}

FeatureBlockContainer.displayName = "FeatureBlockContainer"

FeatureBlockContainer.propTypes = featurePermissionsQueryPropTypes

export default FeatureBlockContainer
